var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.733,
    height: 22.744,
    viewBox: "0 0 23.733 22.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.745,354.472H20.111a3.438,3.438,0,0,0-6.6,0H.989a.989.989,0,0,0,0,1.978H13.511a3.438,3.438,0,0,0,6.6,0h2.633a.989.989,0,0,0,0-1.978Zm-5.933,2.472a1.483,1.483,0,1,1,1.483-1.483A1.485,1.485,0,0,1,16.811,356.944Z",
    transform: "translate(0 -352)",
    fill: "#40404d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.745,13.139H20.111a3.439,3.439,0,0,0-6.6,0H.989a.989.989,0,0,0,0,1.978H13.511a3.438,3.438,0,0,0,6.6,0h2.633a.989.989,0,0,0,0-1.978Zm-5.933,2.472a1.483,1.483,0,1,1,1.483-1.483A1.485,1.485,0,0,1,16.811,15.611Z",
    transform: "translate(0 -10.667)",
    fill: "#40404d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.745,183.806H10.222a3.438,3.438,0,0,0-6.6,0H.989a.989.989,0,0,0,0,1.978H3.622a3.438,3.438,0,0,0,6.6,0H22.744a.989.989,0,0,0,0-1.978ZM6.922,186.278A1.483,1.483,0,1,1,8.406,184.8,1.485,1.485,0,0,1,6.922,186.278Z",
    transform: "translate(0 -181.334)",
    fill: "#40404d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.800efee945b8cd621b3da9fcfd1cf945.svg";
export { ForwardRef as ReactComponent };